<template>
    <img :src="require(`@/assets/images/${url}`)" alt="">
</template>

<script>
export default {
    name: "imgCompifilerComponent",
    props: ['url']
}
</script>